import httpClient from '@/api/httpClient';

const getStockInfo = treatment => httpClient.post(`/api/webShop/stock`, treatment);

export { getStockInfo };
